import { render } from "./ButtonArrowIcon.vue?vue&type=template&id=33985874"
const script = {}

import exportComponent from "C:\\laragon\\www\\carzoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__